/**
 * Remap authoring-layout SVG coords (13671×930 zone) onto screen-overlay %.
 * Zone matches RUNNER_MODIFIER_ZONE raw art coords in runnerConstants.
 */
export const MODIFIER_OVERLAY_ZONE_SVG_X = 5741.5723;
export const MODIFIER_OVERLAY_ZONE_SVG_W = 2187.2659;
export const MODIFIER_OVERLAY_PLAY_H = 930;

export type OverlaySpriteTarget = {
  xPct: number;
  yPct: number;
  widthPct: number;
  heightPct: number;
};

export function svgRectToOverlayPct(
  centerSvgX: number,
  centerSvgY: number,
  widthSvg: number,
  heightSvg: number,
  playHeightSvg: number = MODIFIER_OVERLAY_PLAY_H,
): OverlaySpriteTarget {
  return {
    xPct:
      ((centerSvgX - MODIFIER_OVERLAY_ZONE_SVG_X) / MODIFIER_OVERLAY_ZONE_SVG_W) *
      100,
    yPct: (centerSvgY / playHeightSvg) * 100,
    widthPct: (widthSvg / MODIFIER_OVERLAY_ZONE_SVG_W) * 100,
    heightPct: (heightSvg / playHeightSvg) * 100,
  };
}
